// CE QU'ON PROPOSE À UN CLIENT DONT UNE ŒUVRE EST PRISE PAR QUELQU'UN D'AUTRE.
//
// ═══════════ LE DÉFAUT FERMÉ ICI (QA du 2026-09-09) ═══════════
//
// La modale disait la vérité et ne menait nulle part :
//
//     « L'œuvre "…" est en cours d'achat par un autre client.
//       Elle reste dans votre panier : réessayez dans quelques minutes. »
//
// Un seul bouton, « J'ai compris », et le passage en caisse restait bloqué.
// Un client avec trois œuvres au panier, dont une prise, ne pouvait plus
// commander les DEUX AUTRES : la librairie perdait deux ventes pour une pièce
// qu'elle n'avait de toute façon pas à vendre.
//
// Garder l'œuvre dans le panier était le bon réflexe — on ne retire jamais rien
// sans que le client l'ait demandé, c'est la règle de tout ce chantier. Ce qui
// manquait, c'est de lui DONNER le geste : retirer, ou attendre.
//
// ═══════════ POURQUOI LE CHOIX N'EST PAS TOUJOURS OFFERT ═══════════
//
// Quand TOUT le panier est retenu, « retirer pour commander le reste » ne
// désigne rien : le reste est vide. Proposer ce bouton mènerait à un panier
// vide et à un écran qui ne dit plus rien de ce qui vient de se passer. Dans ce
// cas la modale redevient un simple constat.
//
// ⚠️ CE MODULE NE RETIRE RIEN ET NE COMMANDE RIEN. Il choisit la forme de la
// question. Le geste appartient à l'appelant, et le client garde le dernier
// mot : ne rien faire laisse le panier exactement dans l'état où il était.

export interface ChoixPanierRetenu {
  /**
   * Vrai quand il reste quelque chose à commander une fois les œuvres retenues
   * mises de côté — donc quand le retrait a un objet.
   */
  proposerLeRetrait: boolean;
  /** Le nombre d'œuvres retenues, pour le pluriel des libellés. */
  nombreRetenu: number;
}

/**
 * Décide de la forme de la modale.
 *
 * `nombreRetenu` est le nombre de lignes tenues par quelqu'un d'autre ;
 * `nombreDeLignes`, la taille du panier. Les deux viennent du même contrôle, au
 * même instant : les comparer ailleurs ferait dépendre la décision de la
 * fraîcheur de deux lectures.
 */
export function choisirLaSuitePourPanierRetenu(
  nombreRetenu: number,
  nombreDeLignes: number,
): ChoixPanierRetenu {
  return {
    // Strictement supérieur : à égalité, tout le panier est retenu et il n'y a
    // pas de « reste » à commander.
    proposerLeRetrait: nombreRetenu > 0 && nombreDeLignes > nombreRetenu,
    nombreRetenu,
  };
}
